export default "/images/logo.svg?c69d53a5aa515072e64e7e6c10291e5e";